const dataCustomSort = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M4.25 13.43v-9.4"/><polyline points="1.75 6.57 4.27 3.42 6.75 6.51"/><text stroke-width="0" font-family="Roboto-Regular, Roboto" font-size="10"><tspan x="7.98" y="10.08">5</tspan></text></svg>',
};

export { dataCustomSort as default };
